/**
 * Returns allow(key, now?) -> true at most once per key per intervalMs (first call always passes).
 * intervalMs <= 0 disables throttling.
 */
export function createRepeatGate(intervalMs) {
  const last = new Map();
  return (key, now = Date.now()) => {
    if (!(intervalMs > 0)) return true;
    const prev = last.get(key);
    if (prev !== undefined && now - prev < intervalMs) return false;
    last.set(key, now);
    return true;
  };
}
